import React, { useRef } from 'react'
import { SITE_ID } from '../../../../constants'
import { DashboardDataLayers } from '../../../../constants/gtm-events/gtm-events-dashboard'
import { Label } from './mixins'
import { Tooltip } from '@navent-jobs/ui-kit/components/tooltip'
import IconButton from '../IconButton'
import { salesAndAssist } from '../../../../constants/contact'
import { useTheme } from '../../../../hooks/theme-hook'

const Component = () => {
  const siteId = SITE_ID || 'BMAR'
  const urlAyuda = salesAndAssist[siteId].asistencia
  const { colors } = useTheme()
  const backgroundColor = colors.secondary.lighten

  const onClick = async () => {
    await DashboardDataLayers.clickMenuHeader('Ayuda')
    window.open(urlAyuda, '_blank')
  }

  const itemRef = useRef(null)

  return (
    <>
      <div ref={itemRef}>
        <IconButton onClick={onClick} iconName="icon-light-question-circle" />
      </div>
      <Tooltip
        toggleElement={itemRef}
        background={backgroundColor}
        width="62"
        position="bottom"
        color="white"
        align="center"
      >
        <Label>Ayuda</Label>
      </Tooltip>
    </>
  )
}

export default React.memo(Component)
